"use strict";

module.exports = function (element) {
    var $el = $(element);
    var $stickyHeader = $(".fixed-top");
    var fixedHeaderHeight = $stickyHeader && $stickyHeader.length ? $stickyHeader.height() + 40 : 0;
    var position = $el && $el.length ? $el.offset().top - fixedHeaderHeight : 0;

    window.scrollTo({
        top: position,
        left: 0,
        behavior: "smooth"
    });

    if (!element) {
        $(".logo-home").focus();
    }
};
